export default (that) => [
  {
    text: that.$l('btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_edit_sample') || '编辑样品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ amzSampleStatus }) => {
      return ['Y', 'D', 'T'].includes(amzSampleStatus)
    },
  },
  {
    text: that.$l('btn_delete_sample') || '删除样品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ amzSampleStatus }) => {
      return ['Y', 'D', 'T'].includes(amzSampleStatus)
    },
  },
  {
    text: that.$l('btn_copy_sample') || '复制样品',
    icon: 'el-icon-document-copy',
    menuType: 'copy',
    allow: 'C',
    disabled: ({ amzSampleStatus }) => {
      return ['D', 'T'].includes(amzSampleStatus)
    },
  },
  {
    text: that.$l('btn_review_sample') || '审核信息',
    icon: 'el-icon-s-check',
    menuType: 'review',
    allow: 'A',
    divided: true,
    disabled: ({ amzSampleStatus }) => {
      return ['Y', 'D', 'T'].includes(amzSampleStatus)
    },
  },
  {
    text: that.$l('btn_stop_sample') || '停用样品',
    icon: 'el-icon-switch-button',
    menuType: 'stop',
    allow: 'T',
    disabled: ({ amzSampleStatus }) => {
      return !['Y'].includes(amzSampleStatus)
    },
  },
  {
    text: that.$l('btn_print') || '打印标签',
    icon: 'el-icon-collection-tag',
    menuType: 'print',
    allow: 'P',
    divided: true,
    disabled: ({ amzSampleStatus }) => {
      return !['Y'].includes(amzSampleStatus)
    },
  },
  {
    text: that.$l('btn_shelve_sample') || '样品上架',
    icon: 'el-icon-rank',
    menuType: 'shelve',
    allow: 'S',
    disabled: ({ amzSampleStatus }) => {
      return !['Y'].includes(amzSampleStatus)
    },
  },
]
